// extracted by mini-css-extract-plugin
module.exports =  {"table":"Table-module__table___yb2Ij","nativevalue":"Table-module__nativevalue___P47n0"};